<template lang="html">
    <section class="update-status">
        <h1>{{ $t("StatStatus.titleArchived") }}</h1>
        <p>{{ $t("StatStatus.contentArchived") }} {{ action.archived ? $t("StatStatus.labelDesarchived") : $t("StatStatus.labelArchived") }}</p>
        <button class="btn" @click.prevent="hideModal">{{ $t("StatStatus.cancel") }}</button>
        <button type="submit" class="btn" @click.prevent="updateThisArchive(action);">
            {{ action.archived ? $t("StatStatus.labelDesarchived") : $t("StatStatus.labelArchived") }}
        </button>
    </section>
</template>

<script lang="js">
// import {mapActions} from 'vuex'
import httpService from '../../../components/service'

export default {
    name: 'update-status',
    props: [
        'action'
    ],
    mounted () {

    },
    data () {
        return {}
    },
    methods: {
        // ...mapActions({
        //     listCountDown: 'countdown/listCountDown'
        // }),
        updateThisArchive: function (value) {
            let obj = {
                archived: value.archived
            }
            httpService.post('/plano/' + value.id + '/archived', JSON.stringify(obj)).then(response => {
                console.log('+response+', response)
                if (response.code === 400 || response.code === 404) {
                    value.errorMsg = true
                    this.msgChangeStatus = {
                        en: 'Error. Please contact application Support',
                        fr: "Erreur. Veuillez contacter l'assistance "
                    }
                    // console.log('+response+', response.message)
                    console.error('...+ ERROR DeleteCountDown +....', response)
                    // this.listCountDown()
                } else {
                    this.$root.$emit('bv::hide::modal', 'defaultModalStatus')
                    location.reload()
                    console.log('+response OK+', response)
                }
            })
        },
        /**
         * Function hide Modal
         */
        hideModal: function () {
            this.$root.$emit('bv::hide::modal', 'defaultModalStatus')
        }
    },
    computed: {}
}
</script>

<style scoped lang="scss">
.update-status {
}
</style>



// WEBPACK FOOTER //
// UpdateArchive.vue?360bed38